import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: false,
    employees: [],
    employee: {},
    pagination: {},
    searchCondition: {},
    employeeContract:{},
    showDetailModal: false,
    showContractDetailModal:false
};

const EmployeeReducer = (state = initialState, action = 'none') => {
    switch (action.type) {
        case ActionTypes.ORG_EMPLOYEE_LOADING:
            return Object.assign({}, state, {
                isLoading: action.isLoading
            });
        case ActionTypes.ORG_EMPLOYEE_REFRESH_SEARCH_CONDITION:
            return Object.assign({}, state, {
                searchCondition: action.searchCondition
            });
        case ActionTypes.ORG_EMPLOYEE_TOGGLE_DETAIL_MODAL:
            return Object.assign({}, state, {
                showDetailModal: action.showDetailModal
            });
        case ActionTypes.ORG_EMPLOYEE_REFRESH_EMPLOYEE:

            return Object.assign({}, state, {
                employee: action.employee
            });
        case ActionTypes.ORG_EMPLOYEE_SEARCH:
            return Object.assign({}, state, {
                employees: action.employees,
                pagination: action.pagination
            });
        case ActionTypes.ORG_EMPLOYEE_CONTRACT_REFRESH_CONTRACT:
            return Object.assign({}, state, {
                employeeContract: action.employeeContract,
            });
        case ActionTypes.ORG_EMPLOYEE_CONTRACT_TOGGLE_DETAIL_MODAL:
            return Object.assign({}, state, {
                showContractDetailModal: action.showContractDetailModal
            });

        default:
            return state
    }
};

export default EmployeeReducer;